<div class="product-selection-container w-full h-full">
  <div class="flex gap-4 w-full h-full">
    <!-- Column 1: Product selection -->
    <div class="flex-1 min-w-0">
      <p-card
        styleClass="mb-2 bg-zinc-900 border border-zinc-700"
        class="product-card"
      >
        <ng-template pTemplate="header">
          <div
            class="flex items-center justify-between px-3 py-2 bg-zinc-800 rounded-t-lg"
          >
            <div class="flex items-center">
              <i class="pi pi-box text-primary mr-2"></i>
              <h3 class="text-base font-medium m-0">Produits à programmer</h3>
            </div>
          </div>
        </ng-template>

        <div class="p-3 relative">
          <!-- Add full overlay spinner when loading -->
          <div
            *ngIf="loadingProducts"
            class="absolute inset-0 bg-zinc-900/70 z-10 flex items-center justify-center"
          >
            <div class="flex flex-col items-center">
              <p-progressSpinner
                [style]="{ width: '40px', height: '40px' }"
              ></p-progressSpinner>
            </div>
          </div>

          <div id="product-selection" class="flex flex-col gap-1">
            <!-- Display selected products count -->
            <div class="mb-2">
              <h4 class="text-sm font-semibold text-neutral-400 mb-1">
                {{ selectedProducts.length }} produit{{
                  selectedProducts.length > 1 ? 's' : ''
                }}
                sélectionné{{ selectedProducts.length > 1 ? 's' : '' }}
              </h4>
            </div>

            <!-- Individual Products -->
            <div *ngIf="uniqueProducts && uniqueProducts.length">
              <h4 class="text-sm font-semibold text-neutral-400 mb-1">
                Produits disponibles
              </h4>
              <div *ngIf="loadingProducts" class="flex justify-center p-2">
                <p-progressSpinner
                  [style]="{ width: '24px', height: '24px' }"
                ></p-progressSpinner>
              </div>
              <p-scrollPanel
                styleClass="products-scroll"
                [style]="{ 'max-height': '180px' }"
              >
                <div
                  *ngFor="let product of uniqueProducts"
                  class="product-item border p-2 rounded-lg mb-1"
                  [class.selected-for-group]="product.selected"
                >
                  <!-- Modified layout with improved spacing for duration -->
                  <div class="flex items-center">
                    <div class="flex-grow flex items-center min-w-0 mr-2">
                      <p-checkbox
                        [ngModel]="product.selected"
                        (onChange)="
                          toggleProductSelection(product, $event.checked)
                        "
                        [binary]="true"
                        class="mr-2 shrink-0"
                      ></p-checkbox>
                      <span class="text-sm font-medium truncate">{{
                        product.product.name
                      }}</span>
                    </div>
                    <span
                      class="text-xs bg-neutral-800 px-2 py-1 rounded shrink-0 w-[70px] text-center"
                    >
                      {{ getDurationDisplay(product) }}
                    </span>
                  </div>
                  <p class="text-xs text-neutral-400 mt-1 ml-5 truncate">
                    {{ product.orderId || product.product.reference }}
                  </p>
                </div>
              </p-scrollPanel>
            </div>
            <div
              *ngIf="!uniqueProducts || uniqueProducts.length === 0"
              class="text-center p-3"
            >
              <p class="text-xs text-neutral-400">Aucun produit à programmer</p>
            </div>

            <!-- Action buttons -->
            <div class="flex justify-between mt-3">
              <button
                pButton
                type="button"
                label="Tout sélectionner"
                class="p-button-sm p-button-outlined"
                (click)="selectAll()"
              ></button>
              <button
                pButton
                type="button"
                label="Réinitialiser"
                class="p-button-sm p-button-outlined p-button-danger"
                (click)="clearSelection()"
              ></button>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <!-- Column 2: Affair information -->
    <div *ngIf="affair" class="flex-1 min-w-0">
      <p-card
        styleClass="mb-2 bg-zinc-900 border border-zinc-700"
        class="affair-info-card"
      >
        <ng-template pTemplate="header">
          <div
            class="flex items-center justify-between px-3 py-2 bg-zinc-800 rounded-t-lg"
          >
            <div class="flex items-center">
              <i class="pi pi-folder text-primary mr-2"></i>
              <h3 class="text-base font-medium m-0">Informations affaire</h3>
            </div>
            <span
              class="text-xs px-2 py-1 bg-primary-900 text-primary-200 rounded-md"
            >
              {{ affair.marketType.name || 'NC' }}
            </span>
          </div>
        </ng-template>

        <!-- Basic affair info -->
        <div class="p-3">
          <div class="flex justify-between items-center mb-3">
            <div class="text-xl font-bold text-primary">{{ affair.mlRef }}</div>
          </div>

          <!-- Clients (unified section for both clients) -->
          <div class="mb-3">
            <h4 class="text-sm font-semibold mb-1 flex items-center">
              <i class="pi pi-users mr-1 text-primary-400"></i>
              Clients
            </h4>
            <div class="pl-5">
              <!-- Premier client -->
              <div class="text-sm font-medium">
                {{ affair.finalCustomerFirstname }}
                {{ affair.finalCustomerLastname }}
              </div>
              <div class="flex flex-col gap-1 mb-2">
                <div
                  class="text-xs text-neutral-400 flex items-center"
                  *ngIf="affair.finalCustomerEmail"
                >
                  <i class="pi pi-envelope text-neutral-500 mr-1"></i>
                  <a
                    href="mailto:{{ affair.finalCustomerEmail }}"
                    class="hover:text-primary"
                  >
                    {{ affair.finalCustomerEmail }}
                  </a>
                </div>
                <div
                  class="text-xs text-neutral-400 flex items-center"
                  *ngIf="affair.finalCustomerPhone"
                >
                  <i class="pi pi-phone text-neutral-500 mr-1"></i>
                  <a
                    href="tel:{{ affair.finalCustomerPhone }}"
                    class="hover:text-primary"
                  >
                    {{ affair.finalCustomerPhone }}
                  </a>
                </div>
              </div>

              <!-- Deuxième client (si présent) - avec une bordure supérieure légère pour le séparation visuelle -->
              <div
                *ngIf="
                  affair.finalCustomerFirstnameSecondary ||
                  affair.finalCustomerLastnameSecondary
                "
                class="pt-2 mt-2 border-t border-zinc-700"
              >
                <div class="text-sm font-medium">
                  {{ affair.finalCustomerFirstnameSecondary }}
                  {{ affair.finalCustomerLastnameSecondary }}
                </div>
                <div class="flex flex-col gap-1">
                  <div
                    class="text-xs text-neutral-400 flex items-center"
                    *ngIf="affair.finalCustomerEmailSecondary"
                  >
                    <i class="pi pi-envelope text-neutral-500 mr-1"></i>
                    <a
                      href="mailto:{{ affair.finalCustomerEmailSecondary }}"
                      class="hover:text-primary"
                    >
                      {{ affair.finalCustomerEmailSecondary }}
                    </a>
                  </div>
                  <div
                    class="text-xs text-neutral-400 flex items-center"
                    *ngIf="affair.finalCustomerPhoneSecondary"
                  >
                    <i class="pi pi-phone text-neutral-500 mr-1"></i>
                    <a
                      href="tel:{{ affair.finalCustomerPhoneSecondary }}"
                      class="hover:text-primary"
                    >
                      {{ affair.finalCustomerPhoneSecondary }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <h4 class="text-sm font-semibold mb-1 flex items-center">
              <i class="pi pi-info mr-1 text-primary-400"></i>
              Informations
            </h4>
            <div class="pl-5">
              <div class="text-sm">
                Accompagnateur RENOV' :
                <i
                  class="tll fa-logo-{{ affair.erpSource }} text-{{
                    affair.erpSource
                  }} text-lg"
                ></i>
              </div>
              <div class="text-sm">
                Lié à Constéo : {{ affair.consteoId ? 'Oui' : 'Non' }}
              </div>
            </div>
          </div>

          <!-- Location info -->
          <div class="mb-3">
            <h4 class="text-sm font-semibold mb-1 flex items-center">
              <i class="pi pi-map-marker mr-1 text-primary-400"></i>
              Adresse du chantier
            </h4>
            <div class="pl-5">
              <div class="text-sm">{{ affair.workSiteComposedAddress }}</div>
              <div class="text-sm">
                {{ affair.workSitePostalCode }} {{ affair.workSiteLocality }}
              </div>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <!-- Column 3: ERP sources info -->
    <div *ngIf="affair" class="flex-1 min-w-0 flex flex-col gap-2">
      <p-card
        styleClass="mb-2 bg-zinc-900 border border-zinc-700"
        class="company-info-card"
      >
        <ng-template pTemplate="header">
          <div
            class="flex items-center justify-between px-3 py-2 bg-zinc-800 rounded-t-lg"
          >
            <div class="flex items-center">
              <i class="pi pi-building text-primary mr-2"></i>
              <h3 class="text-base font-medium m-0">Informations sociétés</h3>
            </div>
          </div>
        </ng-template>

        <div class="p-3">
          <!-- Avertissements pour ERPs manquants -->
          <div *ngIf="getMissingErpWarnings().length > 0" class="mb-3">
            <div
              *ngFor="let warning of getMissingErpWarnings()"
              class="warning-message p-2 mb-2 bg-yellow-900 border border-yellow-700 rounded text-yellow-200 text-sm"
            >
              <i class="pi pi-exclamation-triangle mr-2 text-yellow-300"></i>
              {{ warning }}
            </div>
          </div>

          <div *ngFor="let erpSource of getErpEntries()" class="mb-3 last:mb-0">
            <div
              *ngIf="erpSource.value"
              class="erp-section border-b border-neutral-700 pb-2 last:border-b-0"
            >
              <div class="flex items-center justify-between mb-2">
                <div class="flex items-center gap-2">
                  <i
                    class="tll tll-16"
                    [ngClass]="[
                      getErpCssClass(erpSource.key),
                      getLogoClass(erpSource.key),
                    ]"
                  ></i>
                  <h4 class="text-sm font-medium m-0">
                    {{ erpSource.key | uppercase }}
                  </h4>
                </div>
              </div>

              <!-- Administrative Note -->
              <div
                *ngIf="erpSource.value.administrativeInternalNote"
                class="mb-3 administrative-note"
              >
                <div class="text-xs opacity-70 mb-1">Note administrative :</div>
                <div
                  class="note-content p-2 bg-neutral-800 rounded border border-neutral-700"
                  [innerHTML]="erpSource.value.administrativeInternalNote"
                ></div>
              </div>

              <!-- Assistant info -->
              <div class="mb-2 pl-1" *ngIf="erpSource.value.userAssistant">
                <div class="flex items-center">
                  <i
                    class="pi pi-user mr-2 text-sm"
                    [ngClass]="getErpCssClass(erpSource.key)"
                  ></i>
                  <div>
                    <div class="text-xs opacity-70">Assistant(e)</div>
                    <div class="text-sm">
                      {{ erpSource.value.userAssistant.firstname }}
                      {{ erpSource.value.userAssistant.lastname }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Technician info -->
              <div class="pl-1" *ngIf="erpSource.value.userTechnician">
                <div class="flex items-center">
                  <i
                    class="pi pi-user-plus mr-2 text-sm"
                    [ngClass]="getErpCssClass(erpSource.key)"
                  ></i>
                  <div>
                    <div class="text-xs opacity-70">Technicien</div>
                    <div class="text-sm">
                      {{ erpSource.value.userTechnician.firstname }}
                      {{ erpSource.value.userTechnician.lastname }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- No technician message -->
              <div
                *ngIf="!erpSource.value.userTechnician"
                class="text-xs text-neutral-500 italic pl-1"
              >
                <i class="pi pi-info-circle mr-1"></i>
                Aucun technicien assigné
              </div>
            </div>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <!-- Fiche bureau - Full width -->
  <app-affair-office-file
    [fullAffairDetails]="fullAffairDetails"
    [loading]="fullAffairLoading"
    [affair]="affair"
    class="mt-4 mb-20 block w-full"
  ></app-affair-office-file>
</div>
